import React from "react";
import { arrayHasAtLeastTwoItems } from "common/utils/arrays";
import { Button } from "../../../../Common/Buttons/Button";
import { Icon } from "../../../../Common/Icons/LucideIcons";
import { MenuButtonsWrapper } from "./__styles__/SubmissionsBuilder";
import { useBuilderFormContext } from "./form/form";
import { useSubmitForm } from "./form/submission/submit";
import {
  SUBMISSIONS_BUILDER_MODE,
  useSubmissionsBuilderContext,
  useSubmissionsBuilderMode,
} from "./SubmissionsBuilderContext";

export function MenuButtons({
  chatToggleButton,
}: {
  chatToggleButton?: React.ReactNode;
}) {
  const { formState } = useBuilderFormContext();
  const [mode, setMode] = useSubmissionsBuilderMode();
  const { existingSubmissionType } = useSubmissionsBuilderContext();
  const hasVersionHistory = arrayHasAtLeastTwoItems(
    existingSubmissionType?.versions ?? [],
  );
  const submitForm = useSubmitForm();

  const isSubmitDisabled =
    !formState.isDirty || mode !== SUBMISSIONS_BUILDER_MODE.BUILD;

  const canOpenVersionHistory =
    hasVersionHistory &&
    mode === SUBMISSIONS_BUILDER_MODE.BUILD &&
    !formState.isDirty;

  return (
    <MenuButtonsWrapper>
      {mode === SUBMISSIONS_BUILDER_MODE.VERSION_HISTORY ?
        <Button
          variant="outline"
          size="small"
          onPress={() => setMode(SUBMISSIONS_BUILDER_MODE.BUILD)}
          title="Return to current version"
        />
      : canOpenVersionHistory ?
        <Icon
          iconName="history"
          color="contentSecondary"
          size={16}
          cursor="pointer"
          testId="version-history"
          onClick={() => setMode(SUBMISSIONS_BUILDER_MODE.VERSION_HISTORY)}
        />
      : null}
      <Button
        variant="primary"
        size="small"
        isDisabled={isSubmitDisabled}
        isPending={formState.isSubmitting}
        onPress={() => submitForm()}
        title="Save"
      />
      {chatToggleButton}
    </MenuButtonsWrapper>
  );
}
